import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Loader.scss'


const Loader = ({ error, className, style, name, onClick }) => {
  if (error) {
    console.error(error)
  }

  return (
    <div className={cx(s.loaderContainer, className)} style={style} data-name={name}>
      <div className={s.loader} onClick={onClick} />
    </div>
  )
}

Loader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string, // loader name to check in inspector which one is visible
  onClick: PropTypes.func,
}


export default Loader
